var Backbone, FAQAutoCompleteItemView, FAQAutoSuggestionListView, FAQSearchModel, FaqAutosuggestionlistTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FAQSearchModel = require('../models/search');

FAQAutoCompleteItemView = require('./autocompleteItem');

Backbone = require('backbone');

Backbone.$ = $;

FaqAutosuggestionlistTemplate = require('../../autosuggestionlist.html.mustache');

FAQAutoSuggestionListView = (function(superClass) {
  extend(FAQAutoSuggestionListView, superClass);

  function FAQAutoSuggestionListView() {
    return FAQAutoSuggestionListView.__super__.constructor.apply(this, arguments);
  }

  FAQAutoSuggestionListView.VIEWID = 3;

  FAQAutoSuggestionListView.VIEWNAME = "autosuggest";

  FAQAutoSuggestionListView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.faq';
    this.template = FaqAutosuggestionlistTemplate;
    this.breadCrumbView = this.options.breadCrumbView;
    this.container = this.options.container;
    this.spinner = this.options.spinner;
    this.errorContainer = this.options.errorContainer;
    return this.searchModel = new FAQSearchModel();
  };

  FAQAutoSuggestionListView.prototype.render = function(searchText) {
    this.container.empty();
    this.errorContainer.empty();
    this.spinner.show();
    return this.getSuggestions(searchText);
  };

  FAQAutoSuggestionListView.prototype.getSuggestions = function(keyword) {
    if (this.isValid(keyword)) {
      this.searchModel.setUrl(keyword);
      this.searchModel.fetch({
        success: (function(_this) {
          return function(model, response, options) {
            stopTimer("t_fa");
            _this.spinner.hide();
            return _this.renderSuggestions(response);
          };
        })(this),
        error: (function(_this) {
          return function(model, xhr, options) {
            stopTimer("t_fa");
            _this.spinner.hide();
            return _this.renderNoSuggestions(keyword, 'failure');
          };
        })(this)
      });
      return startTimer("t_fa");
    }
  };

  FAQAutoSuggestionListView.prototype.isValid = function(keyword) {
    return (keyword != null) && keyword.length > 0;
  };

  FAQAutoSuggestionListView.prototype.renderBreadCrumbs = function(keyword, text) {
    var leveldata;
    leveldata = {
      searchId: keyword,
      text: text
    };
    this.breadCrumbView.addCrumbs(leveldata);
    return this.breadCrumbView.render();
  };

  FAQAutoSuggestionListView.prototype.renderSuggestionElements = function(response) {
    var $autoSuggestionList;
    $autoSuggestionList = $("#suggestion-list", this.$el);
    return _.each(response.docs, (function(_this) {
      return function(item, index) {
        var autoCompleteItem, hash;
        autoCompleteItem = new FAQAutoCompleteItemView();
        hash = {
          item: item,
          keyword: response.query,
          index: index
        };
        autoCompleteItem.render(hash);
        return $autoSuggestionList.append(autoCompleteItem.el);
      };
    })(this));
  };

  FAQAutoSuggestionListView.prototype.toHtml = function(data, template) {
    if (data == null) {
      data = {};
    }
    if (template == null) {
      template = this.template;
    }
    this.$el.html(toHtml(template, data, this.I18nScope));
    return this.container.html(this.el);
  };

  return FAQAutoSuggestionListView;

})(Backbone.View);

module.exports = FAQAutoSuggestionListView;

//# sourceMappingURL=data:application/json;base64,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
